import { useState, useEffect } from 'react';

type BreakpointSize = 'l' | 'm' | 's';

interface UseWidthReturn {
  size: BreakpointSize;
  width: number;
}

const getBreakpoint = (width: number): BreakpointSize => {
  if (width > 1366) {
    return 'l';
  } else if (width >= 1024) {
    return 'm';
  } else {
    return 's';
  }
};

export const useWidth = (): UseWidthReturn => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [size, setSize] = useState<BreakpointSize>(getBreakpoint(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      setSize(getBreakpoint(newWidth));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { size, width };
};

